import { render, staticRenderFns } from "./TaskBoard.vue?vue&type=template&id=67b7c848&scoped=true"
import script from "./TaskBoard.vue?vue&type=script&lang=ts"
export * from "./TaskBoard.vue?vue&type=script&lang=ts"
import style0 from "./TaskBoard.vue?vue&type=style&index=0&id=67b7c848&prod&lang=scss"
import style1 from "./TaskBoard.vue?vue&type=style&index=1&id=67b7c848&prod&lang=scss"
import style2 from "./TaskBoard.vue?vue&type=style&index=2&id=67b7c848&prod&scoped=true&lang=css"
import style3 from "./TaskBoard.vue?vue&type=style&index=3&id=67b7c848&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b7c848",
  null
  
)

export default component.exports